import {
  Address,
  NONFUNGIBLE_POSITION_MANAGER,
  TokenId,
  getChainConstant,
} from 'nftx.js';
import { useContractRead } from 'wagmi';
import { useNetwork } from '../context/network';
import { NonfungiblePositionManager } from '@nftx/abi';

const useLiquidityPositionSvg = ({
  tokenId,
  manager,
}: {
  manager: Address;
  tokenId: TokenId;
}) => {
  const { network } = useNetwork();

  const { data } = useContractRead({
    address: manager || getChainConstant(NONFUNGIBLE_POSITION_MANAGER, network),
    abi: NonfungiblePositionManager,
    functionName: 'tokenURI',
    args: [BigInt(tokenId)],
    enabled: !!tokenId,
  });

  const uri = data?.split('data:application/json;base64,')[1];

  const image = uri ? (JSON.parse(atob(uri))?.image as string) : undefined;

  return image;
};

export default useLiquidityPositionSvg;
